import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSave = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-save",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" }),
		/* @__PURE__ */ _jsx("polyline", { points: "17 21 17 13 7 13 7 21" }),
		/* @__PURE__ */ _jsx("polyline", { points: "7 3 7 8 15 8" })
	]
});
export default SvgSave;
